"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var StyledBanner_1 = __importDefault(require("./StyledBanner"));
var icons_1 = require("../Icons/icons");
var Banner = function (_a) {
    var heading = _a.heading, text = _a.text, _b = _a.action, action = _b === void 0 ? null : _b, onClose = _a.onClose, warning = _a.warning, success = _a.success, error = _a.error, large = _a.large, children = _a.children, rest = __rest(_a, ["heading", "text", "action", "onClose", "warning", "success", "error", "large", "children"]);
    var isInforamational = !warning && !success && !error;
    return (react_1.default.createElement(StyledBanner_1.default.Container, __assign({}, rest, { warning: warning, success: success, error: error }),
        react_1.default.createElement(StyledBanner_1.default.IconBox, null,
            warning && react_1.default.createElement(icons_1.Warn24, { color: { light: 'yellow700', dark: 'yellow700' } }),
            success && react_1.default.createElement(icons_1.CheckFull16, { color: { light: 'green700', dark: 'green700' } }),
            error && react_1.default.createElement(icons_1.Warn20, { color: { light: 'red700', dark: 'red700' } }),
            isInforamational && react_1.default.createElement(icons_1.Info20, { color: { light: 'gray600', dark: 'grayBlue200' } })),
        react_1.default.createElement(Box_1.default, { column: true },
            heading && react_1.default.createElement(StyledBanner_1.default.Heading, { strong: true }, heading),
            children && (react_1.default.createElement(Box_1.default, { column: !large },
                react_1.default.createElement(StyledBanner_1.default.Content, { margin: !large ? [0] : [0, 2, 0, 0] }, children),
                action && (react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(StyledBanner_1.default.CustomLink, { isInforamational: isInforamational, onClick: action.onClick, secondary: true }, action.text)))))),
        onClose && react_1.default.createElement("span", { onClick: onClose, role: "img" },
            react_1.default.createElement(icons_1.Close20, { color: { light: 'gray600', dark: !isInforamational ? 'gray850' : 'grayBlue200' } }))));
};
exports.default = Banner;
